import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const EmployeesEditToggle = ({ company, subcompany, employee: custom_field_employee, t }) => (
  <Form.Link
    className="btn btn-outline-primary btn-sm mx-2"
    to={createRoute(
      company.id,
      subcompany.id,
      `custom_fields_employees/${custom_field_employee.id}/edit`
    )}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(EmployeesEditToggle);



// WEBPACK FOOTER //
// src/modules/secured/modules/custom_fields_employees/components/list/actions/EmployeesActionsEdit.js